var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodataimg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1914 130.313L77.5004 119.249V73.8877L42.1914 84.8664V130.313Z",
    fill: "#D5DAE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.809 130.313L77.5 119.249V73.8877L112.809 84.8664V130.313Z",
    fill: "#F1F3FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M112.809 130.313L77.5 119.249V73.8877L112.809 84.8664V130.313Z",
    fill: "#AAB2C5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1914 130.313L77.5004 119.249V73.8877L42.1914 84.8664V130.313Z",
    fill: "url(#paint0_linear_6642_12076)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.809 130.313L77.5004 119.249V73.8877L112.809 84.8664V130.313Z",
    fill: "url(#paint1_linear_6642_12076)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5004 141.463L42.1914 130.399V85.0371L77.5004 96.1009V141.463Z",
    fill: "#F1F3FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 141.463L112.809 130.399V85.0371L77.5 96.1009V141.463Z",
    fill: "#D5DAE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M69.5004 133.463L42.1914 130.399V85.0371L77.5004 96.1009L69.5004 133.463Z",
    fill: "url(#paint2_linear_6642_12076)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.5 125.463L112.809 130.399V85.0371L77.5 96.1009L85.5 125.463Z",
    fill: "url(#paint3_linear_6642_12076)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 73.8879L60.8989 61.4624L25 73.5475L42.191 84.8667L77.5 73.8879Z",
    fill: "#D5DAE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 73.8879L94.1011 61.4624L130 73.5475L112.809 84.8667L77.5 73.8879Z",
    fill: "#D5DAE5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M42.191 85.0371L77.5 96.1009L59.8876 107.335L25 95.7605L42.191 85.0371Z",
    fill: "#F1F3FA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M112.809 85.0371L77.5 96.1009L95.1124 107.335L130 95.7605L112.809 85.0371Z",
    fill: "#F1F3FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3515 30.3389C92.2981 43.7634 93.7725 46.7462 94.2564 59.9741C94.0703 62.9936 93.9549 66.277 92.5313 68.9208C90.6302 72.9653 85.9802 75.7663 81.5869 75.8116C77.0609 75.8925 72.6238 73.1214 70.6267 68.8483C69.2216 66.255 69.2663 62.7077 71.1937 60.3531C73.289 58.095 76.9752 57.532 79.6269 58.9429C82.5438 60.2829 84.2848 63.069 84.9297 66.0074C85.5745 68.9457 85.2912 72.1327 84.504 75.0303C82.8578 82.0778 81.4943 82.4187 77.457 94.3505",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3709 23.2335C93.3595 25.2075 91.5225 26.4162 89.1929 25.7859C86.7402 25.3678 85.0042 24.9368 84.8925 23.175C84.9488 21.3682 86.9201 20.6611 89.2274 19.8639C91.994 18.7646 93.2144 21.3045 93.3709 23.2335Z",
    fill: "#D5DAE5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5221 29.2699C78.7652 30.5495 81.3859 30.9226 82.663 28.968C84.0633 26.8012 85.262 25.226 83.9742 23.7792C82.7311 22.4995 81.5214 23.3611 78.7548 24.4604C76.5371 25.5919 76.0663 27.868 77.5221 29.2699Z",
    fill: "#D5DAE5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2573 21.1048C84.3886 20.6226 85.7438 20.9763 86.3484 21.8894C86.606 22.1788 86.9083 22.6353 86.9979 22.9697C87.9608 25.2202 87.658 27.4514 86.3587 27.9785C84.9362 28.7179 82.9764 27.4511 82.2263 25.3227C82.0472 24.654 81.9576 24.3196 81.8233 23.8181C81.6779 22.6028 82.126 21.5869 83.2573 21.1048C83.4253 21.0598 83.2573 21.1048 83.2573 21.1048Z",
    fill: "#AAB2C5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2573 58.3025C31.2573 57.7668 30.823 57.3326 30.2874 57.3326H30.0672C29.5149 57.3326 29.0672 56.8849 29.0672 56.3326V56.0812C29.0672 55.5628 28.647 55.1426 28.1286 55.1426C27.6103 55.1426 27.19 55.5628 27.19 56.0812V56.3326C27.19 56.8849 26.7423 57.3326 26.19 57.3326H25.9699C25.4342 57.3326 25 57.7668 25 58.3025C25 58.8381 25.4342 59.2724 25.9699 59.2724H26.19C26.7423 59.2724 27.19 59.7201 27.19 60.2724V60.5238C27.19 61.0422 27.6103 61.4624 28.1286 61.4624C28.647 61.4624 29.0672 61.0422 29.0672 60.5238V60.2724C29.0672 59.7201 29.5149 59.2724 30.0672 59.2724H30.2874C30.823 59.2724 31.2573 58.8381 31.2573 58.3025Z",
    fill: "url(#paint4_linear_6642_12076)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9902 113.944C36.109 113.422 35.7819 112.902 35.2596 112.784L35.0449 112.735C34.5064 112.612 34.1692 112.076 34.2917 111.538L34.3475 111.293C34.4625 110.787 34.146 110.284 33.6405 110.169C33.1351 110.054 32.6321 110.371 32.5171 110.876L32.4613 111.121C32.3388 111.66 31.8029 111.997 31.2644 111.875L31.0497 111.826C30.5274 111.707 30.0076 112.034 29.8888 112.556C29.77 113.079 30.0971 113.598 30.6194 113.717L30.834 113.766C31.3726 113.889 31.7098 114.424 31.5873 114.963L31.5315 115.208C31.4165 115.714 31.733 116.217 32.2385 116.332C32.7439 116.447 33.2469 116.13 33.3619 115.625L33.4177 115.379C33.5402 114.841 34.0761 114.504 34.6146 114.626L34.8293 114.675C35.3516 114.794 35.8713 114.467 35.9902 113.944Z",
    fill: "url(#paint5_linear_6642_12076)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M131.356 113.296C131.605 112.803 131.407 112.202 130.914 111.953L130.02 111.502C129.527 111.253 129.329 110.651 129.578 110.158L130.03 109.264C130.278 108.771 130.081 108.17 129.588 107.921L129.076 107.662C128.583 107.414 127.982 107.611 127.733 108.104L127.281 108.999C127.032 109.492 126.431 109.69 125.938 109.441L125.044 108.989C124.551 108.74 123.949 108.938 123.7 109.431L123.403 110.019C123.155 110.512 123.352 111.114 123.845 111.362L124.74 111.814C125.233 112.063 125.431 112.664 125.182 113.157L124.73 114.051C124.481 114.545 124.679 115.146 125.172 115.395L125.684 115.653C126.177 115.902 126.778 115.704 127.027 115.211L127.478 114.317C127.727 113.824 128.329 113.626 128.822 113.875L129.716 114.326C130.209 114.575 130.81 114.377 131.059 113.884L131.356 113.296Z",
    fill: "url(#paint6_linear_6642_12076)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6642_12076",
    x1: 66.3541,
    y1: 77.173,
    x2: 61.5381,
    y2: 97.2228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6642_12076",
    x1: 66.3541,
    y1: 77.173,
    x2: 61.5381,
    y2: 97.2228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6642_12076",
    x1: 50.1075,
    y1: 116.082,
    x2: 58.5901,
    y2: 92.1243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#6C80AA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6642_12076",
    x1: 96.5558,
    y1: 122.627,
    x2: 97.2229,
    y2: 92.2243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#314F91",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6642_12076",
    x1: 28.1291,
    y1: 55.3621,
    x2: 28.1291,
    y2: 58.9094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6642_12076",
    x1: 33.5923,
    y1: 110.383,
    x2: 32.8053,
    y2: 113.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6642_12076",
    x1: 129.197,
    y1: 108.06,
    x2: 127.006,
    y2: 112.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataimg);
export default __webpack_public_path__ + "static/media/nodataimg.e7c468bfa45e8e9e119467cd2ed24a75.svg";
export { ForwardRef as ReactComponent };